import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';

interface Props {
    visible: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const UnsavedChangesDialog: React.FC<Props> = ({ visible, onCancel, onConfirm }) => (
    <Dialog maxWidth="xs" open={visible} fullWidth>
        <DialogTitle>Discard Changes?</DialogTitle>
        <DialogContent dividers>
            <Typography variant="body2">
                You have unsaved changes. Leaving this page will discard them.
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={onCancel}>Keep Editing</Button>
            <Button color="warning" onClick={onConfirm} variant="contained">Discard Changes</Button>
        </DialogActions>
    </Dialog>
);

export default UnsavedChangesDialog;